import React from "react";

export function VideoLayout(props) {
  return (
    <div>
      <div className="login-wrapper">{props.children}</div>
    </div>
  );
}
